import ControlPanelMenu from "./control-panel-menu";

export default ControlPanelMenu;